import moment from "moment/moment";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { Container, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import useTrait from "../Common/syncUpdateState";
import styles from "./PartsComponent.module.scss";

const MySwal = withReactContent(Swal);

const showAlert = (error) => {
  MySwal.fire({
    title: "Error Occured!",
    text: error,
    icon: "error",
    timerProgressBar: false,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: "Close",
  });
};

const SiteSearchResult = ({ data, slug, defaultValue }) => {
  const searchResult = data;
  let notFound = "";
  let downloadFileArray = [];
  const hideButton = useTrait(false);
  const ref = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const searchQuery = useTrait(defaultValue.replace(/-/g, " "));
  const router = useRouter();

  const searchQueryChange = (event) => {
    searchQuery.set(event.target.value);
  };

  const onSubmitResult = async (event) => {
    event.preventDefault();
    if (!searchQuery.get()) {
      showAlert("Please enter a search term");
      return;
    }

    if (
      slug.replace(/-/g, " ") ===
      searchQuery
        .get()
        .trim()
        .toLowerCase()
        .replace(/[+\-&&||!(){}\[\]^"~*?:\\]/g, "")
    ) {
      return;
    }

    try {
      hideButton.set(false);
      setIsLoading(true);
      // const query = replaceSpecialChars(searchQuery.get());
      const query = encodeURIComponent(searchQuery.get());
      router.push(`/sitesearch/${query}`);
    } catch (err) {
      setIsLoading(false);
      notFound = "";
      showAlert("Unexpected error occured doing search");
      return;
    }
  };

  React.useEffect(() => {
    setIsLoading(false);
    hideButton.set(false);
  }, [slug]);

  const clearSearch = () => {
    searchQuery.set("");
    ref.current.value = "";
    router.push("/sitesearch/-");
    return;
  };

  downloadFileArray = searchResult?.queryStockDetailContents?.filter(
    (obj) => obj?.flatData?.extraInfo && obj?.flatData?.extraInfo?.downloads
  );

  if (
    slug !== "-" &&
    !searchResult?.queryArticleContents?.length &&
    !searchResult?.queryPagesContents?.length &&
    !searchResult?.queryStockDetailContents?.length
  )
    notFound = `No results for the keyword`;

  return (
    <div>
      <div>
        <div className='container my-3'>
          <div className='row'>
            <div className='offset-md-3 col-md-6 col-xs-12'>
              <div>
                <form className='d-flex'>
                  <input
                    type='text'
                    ref={ref}
                    className='form-control'
                    placeholder='Enter your search keyword'
                    onChange={searchQueryChange}
                    defaultValue={slug ? searchQuery.get() : ""}
                  />
                  <button
                    type='submit'
                    className='btn btn-primary'
                    onClick={onSubmitResult}
                  >
                    {isLoading && (
                      <Spinner
                        as='span'
                        animation='border'
                        size='sm'
                        role='status'
                        aria-hidden='true'
                      />
                    )}
                    {!isLoading && "Search"}
                  </button>{" "}
                  &nbsp;
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={clearSearch}
                  >
                    Clear
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Container>
        {notFound.length > 0 && (
          <>
            <h4 className='m-4 '>{notFound}</h4>
          </>
        )}
        <br />
        {searchResult?.queryStockDetailContents?.length > 0 && (
          <>
            <h3 className='my-4'>Matching Ryco Parts</h3>
            <div className='row'>
              {searchResult?.queryStockDetailContents
                .slice(0, 7)
                .map((item, index) => (
                  <div key={"parts_" + index} className='col-sm-3 mb-3 mb-2'>
                    <div
                      className='product-catalog'
                      style={{ overflow: "hidden" }}
                    >
                      <div
                        className={styles.productImg}
                        style={{ cursor: "pointer" }}
                      >
                        <Link
                          href={`/part/${item?.flatData?.stockCode}`}
                          legacyBehavior
                        >
                          <Image
                            src={item?.flatData?.imageUrl}
                            alt={item?.flatData?.stockCode}
                            width={304}
                            height={223}
                            layout='responsive'
                          />
                        </Link>
                      </div>
                      <div className='product-body'>
                        <span className='product-caption'>
                          <Link
                            href={`/part/${item?.flatData?.stockCode}`}
                            legacyBehavior
                          >
                            <a style={{ color: "#ed1b2f" }}>
                              {item?.flatData?.stockCode}{" "}
                              {item?.flatData?.typeName}
                            </a>
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              {searchResult?.queryStockDetailContents?.length > 7 && (
                <>
                  {hideButton.get() === false ? (
                    <div className='col-sm-3 mb-3 mb-2'>
                      <div
                        className='product-catalog'
                        style={{
                          overflow: "hidden",
                          height: "100%",
                        }}
                        onClick={() => hideButton.set(true)}
                      >
                        <p
                          className='d-flex justify-content-center align-items-center'
                          style={{
                            height: "100%",
                            fontSize: "1.4rem",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          <a
                            data-bs-toggle='collapse'
                            href='#collapseExample'
                            role='button'
                            aria-expanded='false'
                            aria-controls='collapseExample'
                          >
                            View More
                          </a>
                        </p>
                      </div>
                    </div>
                  ) : (
                    <>
                      {searchResult?.queryStockDetailContents
                        .slice(7, 16)
                        .map((item, index) => (
                          <div
                            key={"parts_" + index}
                            className='col-sm-3 mb-3 mb-2'
                          >
                            <div
                              className='product-catalog'
                              style={{ overflow: "hidden" }}
                            >
                              <div
                                className={styles.productImg}
                                style={{ cursor: "pointer" }}
                              >
                                <Link
                                  href={`/part/${item?.flatData?.stockCode}`}
                                  legacyBehavior
                                >
                                  <Image
                                    src={item?.flatData?.imageUrl}
                                    alt={item?.flatData?.stockCode}
                                    width={304}
                                    height={223}
                                    layout='responsive'
                                  />
                                </Link>
                              </div>
                              <div className='product-body'>
                                <span className='product-caption'>
                                  <Link
                                    href={`/part/${item?.flatData?.stockCode}`}
                                    legacyBehavior
                                  >
                                    <a style={{ color: "#ed1b2f" }}>
                                      {item?.flatData?.stockCode}{" "}
                                      {item?.flatData?.typeName}
                                    </a>
                                  </Link>
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                    </>
                  )}
                </>
              )}
            </div>
          </>
        )}
        <br />
        {searchResult?.queryPagesContents?.length > 0 && (
          <>
            <h3 className='mb-4'>Matching Pages</h3>
            <div className='row'>
              <div className='col-sm-12 col-md-6'>
                {searchResult?.queryPagesContents.map((item, index) => (
                  <Link
                    href={`/${item?.flatData?.pageId}`}
                    key={index}
                    legacyBehavior
                  >
                    <div className='mb-2 pages-metadata'>
                      <p
                        style={{
                          color: "#ed1b2f",
                          cursor: "pointer",
                          fontSize: "19px",
                          fontWeight: 600,
                          margin: 0,
                        }}
                      >
                        {item?.flatData?.heading}
                      </p>
                      <a
                        style={{
                          color: "black",
                          cursor: "pointer",
                          fontSize: "15px",
                          fontWeight: 400,
                          textDecoration: "none",
                        }}
                      >
                        {item?.flatData?.metaDescription}
                      </a>
                      <br />
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </>
        )}
        <br />
        {searchResult?.queryArticleContents?.length > 0 && (
          <>
            <h3 className='mb-4'>Matching Articles</h3>
            <div className='row'>
              <div className='col-sm-12 col-md-6'>
                {searchResult?.queryArticleContents.map((item, index) => {
                  const dd = moment(item?.created).format("Do MMM YY");
                  return (
                    <div key={index}>
                      <div
                        className='card mb-3'
                        style={{ maxWidth: "800px", border: "none" }}
                      >
                        <div className='row g-0'>
                          <div className='col-sm-12'>
                            <div className='card-body' style={{ padding: "0" }}>
                              <Link
                                href={`/articles/${item?.flatData?.pageId}`}
                                legacyBehavior
                              >
                                <div className='pages-metadata'>
                                  <p
                                    style={{
                                      color: "#ed1b2f",
                                      cursor: "pointer",
                                      fontSize: "19px",
                                      fontWeight: 600,
                                      margin: 0,
                                    }}
                                  >
                                    {item?.flatData?.heading}
                                  </p>
                                  <a
                                    style={{
                                      color: "black",
                                      cursor: "pointer",
                                      fontSize: "15px",
                                      fontWeight: 400,
                                      textDecoration: "none",
                                    }}
                                  >
                                    {item?.flatData?.subHeading}
                                  </a>
                                </div>
                              </Link>
                              <p className='m-0 p-0 fs-sm'>
                                {item?.flatData?.keywords &&
                                  item?.flatData?.keywords.map((x, idx1) => {
                                    return (
                                      <span
                                        key={idx1}
                                        className='badge rounded-pill bg-secondary'
                                      >
                                        #{x}
                                      </span>
                                    );
                                  })}{" "}
                                {dd}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
        <br />
        {downloadFileArray?.length > 0 && (
          <>
            <h3 className='mb-4'>Downloads</h3>
            <div className='row'>
              <div className='col-sm-12 col-md-6'></div>
            </div>
            {downloadFileArray?.length > 0 && (
              <>
                {downloadFileArray.slice(0, 15).map((item, index) => (
                  <div key={index}>
                    <div
                      className='card mb-4'
                      style={{ maxWidth: "800px", border: "none" }}
                    >
                      <div className='row g-0'>
                        <div className='col-sm-12'>
                          <div className='card-body' style={{ padding: "0" }}>
                            <p
                              style={{
                                color: "black",
                                fontSize: "19px",
                                fontWeight: 600,
                                margin: 0,
                              }}
                            >
                              {item?.flatData?.stockCode} -{" "}
                              <span style={{ color: "#121212" }}>
                                {item?.flatData?.typeName}
                              </span>
                            </p>
                          </div>
                          {item?.flatData?.fitmentGuides &&
                            item?.flatData?.fitmentGuides.map((ft, idx1) => (
                              <div key={idx1} className='my-2'>
                                <Link href={ft?.url} legacyBehavior>
                                  <a
                                    style={{
                                      color: "#ed1b2f",
                                    }}
                                    target='_blank'
                                  >
                                    {ft?.title}
                                  </a>
                                </Link>
                              </div>
                            ))}
                          {item?.flatData?.extraInfo?.downloads &&
                            item?.flatData?.extraInfo.downloads.map(
                              (ft, idx1) => (
                                <div key={idx1} className='my-2'>
                                  <Link href={ft?.file[0]?.url} legacyBehavior>
                                    <a
                                      style={{
                                        color: "#ed1b2f",
                                      }}
                                      target='_blank'
                                    >
                                      {ft?.title}
                                    </a>
                                  </Link>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default SiteSearchResult;

const replaceSpecialChars = (string) => {
  try {
    const decodedString = decodeURIComponent(string); // decode percent-encoded values
    const processedString = decodedString
      .replace(/[^\w\s]|_/g, "")
      .replace(/\s+/g, " ")
      .trim();
    return processedString;
  } catch (error) {
    return string; // return original string if decoding fails
  }
};
